module.exports = __webpack_public_path__ + "static/img/dsv23gx.1583c1ec.png";